export default "__VITE_ASSET__DDxXEnc8__"